import { Component, OnInit, Input } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { HttpService } from '../../../shared/services/http.service';
import { SharedService } from '../../../shared/services/shared.service';
import { DictionaryService } from '../../../shared/services/dictionary.service';
import { ModalsService } from '../../../shared/services/modals.service';

@AutoUnsubscribe()
@Component({
  selector: 'feature-flags-all-networks-component',
  templateUrl: './feature-flags-all-networks.html',
  styleUrls: ['./feature-flags-all-networks.scss'],
})
export class FeatureFlagsAllNetworksComponent implements OnInit {
  @Input() public data: any;
  public featureName: string = null;
  public enabled = false;
  public default = false;
  public isLoading = false;
  public subscriptions: Array<Subscription> = [];

  constructor(
    public httpService: HttpService,
    public sharedService: SharedService,
    public dictionaryService: DictionaryService,
    public modalsService: ModalsService
  ) {}

  ngOnInit() {}

  ngOnDestroy() {}

  confirm() {
    const params: any = {
      networkIds: '*',
      featureName: this.featureName,
      enabled: this.enabled ? 1 : 0,
      default: this.default ? 1 : 0,
    };
    this.isLoading = true;
    this.subscriptions.push(
      this.httpService.post('networks_management/setNetworkFeatures', params).subscribe((response: any) => {
        this.sharedService.showFlashMessage(this.dictionaryService.get('UPDATED_SUCCESSFULLY'), 'success');
        this.sharedService.sendMessage('FEATURE_FLAGS_UPDATED');
        this.isLoading = false;
        this.modalsService.hideModal();
      })
    );
  }
}
